import Reveal from '@/components/feature/Reveal';

const mapsUrl =
  'https://www.google.com/maps/search/?api=1&query=700+Mitchell+Ln%2C+Windsor%2C+CA+95492';

export default function Location() {
  return (
    <section id="location" className="relative py-24 md:py-36 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Expansive%20Northern%20California%20Sonoma%20County%20vineyard%20landscape%20at%20golden%20hour%2C%20rolling%20hills%2C%20warm%20amber%20sunlight%2C%20atmospheric%20mist%2C%20dramatic%20sky%2C%20cinematic%20wide%20shot%2C%20rich%20earthy%20copper%20and%20gold%20tones%2C%20premium%20editorial%20travel%20photography&width=1920&height=1080&seq=brewery-location-03&orientation=landscape"
          alt="Northern California Sonoma County landscape at golden hour"
          title="23 Bottles of Beer LLC — Windsor, Sonoma County, California"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <p className="text-xs tracking-[0.35em] uppercase text-primary-300 mb-4">Location</p>
            <h2 className="font-heading font-semibold text-4xl md:text-5xl text-background-50 leading-tight">
              Crafted in California
            </h2>
            <p className="mt-6 text-background-100/85 text-base md:text-lg leading-relaxed">
              Located in Windsor, California, 23 Bottles of Beer LLC is part of a region
              known for its exceptional food, wine, agriculture, and independent craft
              beverage culture.
            </p>
          </Reveal>

          <Reveal delay={140}>
            <div className="rounded-lg bg-background-50/95 p-8">
              <h3 className="font-heading font-semibold text-xl text-foreground-950">
                23 Bottles of Beer LLC
              </h3>
              <address className="not-italic mt-4 text-foreground-600 leading-relaxed">
                700 Mitchell Ln<br />
                Windsor, CA 95492-6902<br />
                United States
              </address>
              <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="whitespace-nowrap mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600 active:bg-primary-700 transition-colors"
              >
                <i className="ri-navigation-line text-base"></i>
                Get Directions
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}